<template>
  <div class="mid_forget_password mid-auth-container h-100">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div
          class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto"
          id="myIrishDateFormDiv"
        >
         <ResetPassword
            titleH2=""
            welcomeHeader="Reset Passsword"
            welcomeSubheader="Enter your new password to log in to your account now."
            logoSrc="my-irish-date/logo-login.png"
            guard="MID" clientLink="my_irish_date" :token="$route.query.token"
            :email="$route.query.email"
          />
        </div>
        <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 my-auto h-100 p-0">
          <div class="h-100" id="myIrishDateImgDiv">
            <img
              class="img-fluid mx-auto"
              id="myIrishDateIconImg"
              src="@/assets/images/my-irish-date/mid-icon.png"
              alt="mid Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPassword from "@/components/auth/ResetPassword.vue";

export default {
  name: "DoOmYogaResetPassword",
  components: { ResetPassword },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit reset password");
    },
  },
};
</script>
<style>
@import "../css/my-irish-date-fonts.css";
@import "../css/my-irish-date-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/my_irish_date/auth/ResetPasswordView.vue